import { CreditCardOutlined } from '@ant-design/icons';

const subscriptions = {
  id: 'group-subscription',
  title: 'Subscription',
  type: 'group',
  children: [
    {
      id: 'plan',
      title: 'Subscription Plan',
      type: 'item',
      url: '/subscription/plan',
      icon: CreditCardOutlined
    }
  ]
};

export default subscriptions;
